document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-bm-topper-size]')) return;
  event.stopPropagation();
  const field = event.target.closest('fieldset');
  const radio = [...field.querySelectorAll('input[type="radio"]')].find(input => input.value === event.target.value);
  if (radio && !radio.checked) radio.click();
}, true);
window.addEventListener('load', () => {
  document.querySelectorAll('[data-bm-topper-size]').forEach(select => {
    const field = select.closest('fieldset');
    if (field.querySelector('input[type="radio"]:checked')) return;
    const fallback = [...select.options].find(option => !option.disabled);
    const radio = [...field.querySelectorAll('input[type="radio"]')].find(input => input.value === fallback?.value);
    if (radio) radio.click();
  });
});


